import psHttp from '@patsnap/common-ps-http';
import { environment } from './environment';
import { ErrorHandlerService } from './error-handler-service';
import { SystemService } from './system-service';
import { singleton } from './flow';
import { RnDHttp } from './rnd-http';
import { AnalyticsHttp } from './analytics-http';
import { WorkspaceHttp } from './workspace-http';
import { HomeHttp } from './home-http';
import { PaperHttp } from './paper-http';
import { AccountHttp } from './account-http';

export class Container {
  @singleton()
  get SystemService() {
    return new SystemService(environment);
  }

  @singleton()
  get ErrorHandlerService() {
    return new ErrorHandlerService(this.SystemService);
  }

  @singleton()
  get RnDHttp() {
    return new RnDHttp(psHttp, this.ErrorHandlerService);
  }

  @singleton()
  get AnalyticsHttp() {
    return new AnalyticsHttp(psHttp, this.ErrorHandlerService);
  }

  @singleton()
  get WorkspaceHttp() {
    return new WorkspaceHttp(psHttp, this.ErrorHandlerService);
  }

  @singleton()
  get HomeHttp() {
    return new HomeHttp(psHttp, this.ErrorHandlerService);
  }

  @singleton()
  get PaperHttp() {
    return new PaperHttp(psHttp, this.ErrorHandlerService);
  }

  @singleton()
  get AccountHttp() {
    return new AccountHttp(psHttp, this.ErrorHandlerService);
  }
}

export const container = new Container();
